import { debounce } from "lodash";
import { format, isBefore, isValid, subMinutes } from "date-fns";

export const parseFieldArea = (area) => {
  return area ? area.toFixed(2) : "0";
};

export const transformDataToMapboxSource = (data) => {
  return data.map((item) => ({
    type: "geojson",
    data: item,
  }));
};

export const fieldMapImage = (field) => {
  const encodeObject = (object) => {
    return encodeURIComponent(JSON.stringify(object))
      .replace(/'/g, "%27")
      .replace(/"/g, "%22");
  };

  const baseUrl = "https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static";
  const geojson = {
    type: "Feature",
    properties: {
      stroke: "#09BA51",
      "stroke-width": 2,
      "stroke-opacity": 1.0,
    },
    geometry: field.geometry,
  };
  const bBox = field.bbox;
  const mapStyle = "100x100@2x?padding=8";
  const mapboxToken = process.env.REACT_APP_MAPGL_ACCESS_TOKEN;

  return `${baseUrl}/geojson(${encodeObject(
    geojson
  )})/[${bBox}]/${mapStyle}&access_token=${mapboxToken}`;
};

export const addTextChangeDebounce = debounce((func) => func(), 1000, {
  maxWait: 1000,
});

export const getPricing = (priceDetails) => {
  let actualPrice = 0;
  let basePrice = 0;
  let discountValue = "";
  let discountValidity = "";
  const taxRate = priceDetails?.tax_rate;
  if (priceDetails?.discount_denomination === "aud_cents") {
    actualPrice =
      (priceDetails?.base_price - priceDetails?.discount_value) / 100;
    basePrice = priceDetails?.base_price / 100;
    discountValue = `$${priceDetails?.discount_value / 100}`;
  } else {
    actualPrice =
      priceDetails?.base_price * ((100 - priceDetails?.discount_value) / 10000);
    basePrice = priceDetails?.base_price / 100;
    discountValue = `${priceDetails?.discount_value}%`;
  }

  if (isValid(priceDetails?.discount_validity * 1000)) {
    discountValidity = subMinutes(
      new Date(priceDetails?.discount_validity * 1000),
      60
    );
  } else {
    discountValidity = "";
  }

  const isValidDiscount =
    discountValidity && isBefore(new Date(), discountValidity);

  return {
    actualPrice,
    basePrice,
    discountValue,
    discountValidity,
    taxRate,
    isValidDiscount,
  };
};

export const getMachinePrice = (bookingPrice) => {
  let minimumFee = 0;
  let totalPrice = 0;
  let taxRate = 0;

  minimumFee = bookingPrice?.minimum_fee / 100;

  taxRate = minimumFee * (bookingPrice?.tax_rate / 100);
  totalPrice = minimumFee + taxRate;

  return {
    minimumFee,
    taxRate,
    totalPrice,
  };
};

export const getDatesInRange = (startDate, endDate) => {
  const dateStart = new Date(startDate);
  const dateEnd = new Date(endDate);
  const dates = [];
  while (dateStart <= dateEnd) {
    dates.push(format(new Date(dateStart), "MMMM d, yyyy"));
    dateStart.setDate(dateStart.getDate() + 1);
  }
  return dates;
};

export const getTotalFields = (farms) => {
  let sum = 0;
  farms.map((farm) => {
    sum += farm?.properties?.number_of_fields;
    return sum;
  });
  return sum;
};

export const getTotalArea = (farms) => {
  let totalArea = 0;
  farms.map((farm) => {
    totalArea += farm?.properties?.farm_area;
    return totalArea;
  });
  return totalArea.toFixed(2);
};

export const getUserTwitterDomain = (user) => {
  const userDomain = user.split("@")[1];
  return userDomain;
};

export const getZonesTotalArea = (item) => {
  let totalArea = 0;
  item?.details?.zones?.features?.map((field) => {
    totalArea += field.properties.area;
    return totalArea;
  });
  return { totalArea };
};

export const getItemPrice = (items, cost) => {
  let totalArea = 0;
  let itemPrice = 0;
  items?.map((item) => {
    totalArea += item.properties.area;
    return totalArea;
  });
  itemPrice = (Math.ceil(totalArea) * cost) / 100;
  return itemPrice;
};

export const getStackItemPrice = (items, cost) => {
  let totalArea = 0;
  let itemPrice = 0;
  totalArea += items?.fields?.length;
  itemPrice = (Math.ceil(totalArea) * cost) / 100;
  return itemPrice;
};
